<template>
  <div>
    <c-col col="12">
      <loader v-show="loading" />
      <c-card>
        <c-card-header>
          <strong>Warranty</strong>
        </c-card-header>
        <c-card-body>
          <div class="row">
            <div class="col-md-6 padding-15">
              <div class="form-group">
                <label for="wcode">Warranty Code</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="data.warranty"
                  id="wcode"
                  readonly
                />
              </div>
              <div class="form-group">
                <label for="witem">Item</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="data.item.name"
                  id="witem"
                  readonly
                />
              </div>
              <div class="form-group">
                <label for="wcust">Customer</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="data.customer.name"
                  id="wcust"
                  readonly
                />
              </div>
              <div class="form-group">
                <label for="wtypemobil">Tipe Mobil</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="data.type_mobil"
                  id="wtypemobil"
                />
              </div>
              <div class="form-group">
                <label for="wdsale">Date Sale</label>
                <datetime type="date" class="date-control" v-model="data.date_sale" zone="local" value-zone="Asia/Jakarta" />
              </div>
              <div class="form-group">
                <label for="woowaranty">Out of Warranty</label>
                <datetime type="date" class="date-control" v-model="data.out_of_warranty" zone="local" value-zone="Asia/Jakarta" />
              </div>
            </div>
            <div class="col-md-6 padding-15">
              <div class="form-group">
                <label for="wplat">No Plat</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="data.plat"
                  id="wplat"
                />
              </div>
              <div class="form-group">
                <label for="wname">Name</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="data.name"
                  id="wname"
                />
              </div>
              <div class="form-group">
                <label for="waddr">Address</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="data.address"
                  id="waddr"
                />
              </div>
              <div class="form-group">
                <label for="wcity">City</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="data.city"
                  id="wcity"
                />
              </div>
              <div class="form-group">
                <label for="wtoke">Toko</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="data.toko"
                  id="wtoke"
                />
              </div>
              <div class="form-group">
                <label for="wphone">No Phone</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="data.phone"
                  id="wphone"
                />
              </div>
            </div>
          </div>
        </c-card-body>
        <c-card-footer>
          <i-button
            icon="cil-arrow-circle-left"
            color="primary"
            label="Back"
            class="mr-2"
            @action="doBack"
          />
          <i-button
            icon="cil-save"
            color="success"
            label="Save"
            @action="edit"
          />
        </c-card-footer>
      </c-card>
    </c-col>
  </div>
</template>
<script>
import Loader from "../../components/Loader.vue";
import IButton from "../../components/IButton.vue";
import { showErrorMessage, successMessage } from "../../lib/helpers";
import { HTTPAUTH } from "../../lib/httplib";

export default {
  components: {
    Loader,
    IButton,
  },
  data() {
    return {
      data: {},
      loading: true,
    };
  },
  created() {
    const params = this.$route.params;
    if (params && params.code) {
      this.get(params.code);
    }
  },
  methods: {
    get(code) {
      this.loading = true;
      HTTPAUTH.get(`/api/v1/warranty/${code}/code`)
        .then((res) => {
          this.loading = false;
          this.data = res.data.data;
        })
        .catch((eres) => {
          this.loading = false;
          showErrorMessage(eres);
        });
    },
    doBack() {
      this.$router.push({ path: `/product/warranty` });
    },
    edit() {
      this.loading = true;
      HTTPAUTH.put(`/api/v1/warranty/${this.data.warranty}/code`, this.data)
        .then(() => {
          this.loading = false;
          successMessage("Berhasil mengubah data garansi");
        })
        .catch((eres) => {
          this.loading = false;
          showErrorMessage(eres);
        });
    },
  },
};
</script>